import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { singularize, toCamelCase, toPascalCase } from '@cli-utils/text.js'
import { renderVersionSnapshotHelpersRenderer } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/generate-version-snapshot-helpers.js'

export function generateVersionSnapshotHelpers(ctx: EntityCtx): string {
  const snapshotKeys = ctx.versionSnapshotKeys.map((key) => JSON.stringify(key)).join(', ')
  const restoreKeys = ctx.versionRestoreKeys.map((key) => JSON.stringify(key)).join(', ')
  const m2mKeys = ctx.m2mFields.map((field) => JSON.stringify(field.name)).join(', ')
  const loadM2MStatements = ctx.m2mFields
    .map((field) => {
      const rel = field.relationship || ''
      const RelPascal = toPascalCase(rel)
      const relSingular = singularize(rel)
      const junctionVar = toCamelCase(`${ctx.singular}${RelPascal}`)
      const entityIdCol = `${ctx.singular}Id`
      const relIdCol = `${relSingular}Id`

      return renderVersionSnapshotHelpersRenderer({
        kind: 'renderVersionSnapshotHelpersRowsTemplate',
        props: {
          fieldName: field.name,
          relIdCol: relIdCol,
          junctionVar: junctionVar,
          entityIdCol: entityIdCol
        }
      })
    })
    .join('\n')
  const snapshotClientType = ctx.hasM2M
    ? `\ntype VersionSnapshotClient = typeof db | Parameters<Parameters<typeof db.transaction>[0]>[0]\n`
    : ''
  const relationshipSnapshotHelper = ctx.hasM2M
    ? renderVersionSnapshotHelpersRenderer({
        kind: 'renderVersionSnapshotHelpersSourceTemplate',
        props: {
          ctxSingular: ctx.Singular,
          loadM2MStatements: loadM2MStatements
        }
      })
    : ''

  return renderVersionSnapshotHelpersRenderer({
    kind: 'renderVersionSnapshotHelpersGeneratedFunctionTemplate',
    props: {
      snapshotClientType: snapshotClientType,
      snapshotKeys: snapshotKeys,
      restoreKeys: restoreKeys,
      m2mKeys: m2mKeys,
      ctxSingular: ctx.Singular,
      relationshipSnapshotHelper: relationshipSnapshotHelper
    }
  })
}
